import { SvgIconProps, Typography, TypographyProps } from "@mui/material";
import React from "react";
import styles from "./card.module.css";

export const CoreCard = (props: {
	title?: React.ReactNode;
	titleVariant?: TypographyProps["variant"];
	description?: React.ReactNode;
	titleAriaLabelledBy?: string;
	// eslint-disable-next-line deprecation/deprecation
	icon?:
		| React.FunctionComponent<React.SVGProps<SVGSVGElement>>
		| React.ReactNode
		| ((props: SvgIconProps) => JSX.Element);
	children?: React.ReactNode;
	useHeader?: boolean;
	style?: React.CSSProperties;
	headerFontSize?: string | number;
	headerPadding?: string | number;
	fontSize?: string | number;
	lineHeight?: string | number;
	boxShadow?: boolean;
	iconStroke?: boolean;
	padding?: string | number;
	bottomPadding?: string | number;
	className?: string;
	bodyClassName?: string;
	rightTitleContent?: React.ReactNode;
	rightContent?: React.ReactNode;
}) => {
	const title = (props.title || props.icon) && (
		<div
			className={props.useHeader ? styles.cardTitleHeader : styles.cardTitle}
			style={{ fontSize: props.headerFontSize, padding: props.headerPadding }}
		>
			{props.icon && (
				<div
					className={`${props.useHeader ? styles.cardTitleIconHeader : styles.cardTitleIcon} ${
						props.iconStroke ? styles.strokeColor : ""
					}`}
					style={{ width: props.headerFontSize, height: props.headerFontSize }}
				>
					{typeof props.icon !== "function" ? (
						props.icon
					) : (
						<props.icon style={{ width: props.headerFontSize, height: props.headerFontSize }} />
					)}
				</div>
			)}
			<div className={styles.cardTitleRightContent}>
				{props.title && (
					<Typography
						variant={props.titleVariant ?? "h2"}
						className={styles.cardTitleText}
						fontSize={props.headerFontSize ?? "18px"}
						id={props.titleAriaLabelledBy}
					>
						{props.title}
					</Typography>
				)}
				{props.rightTitleContent}
			</div>
		</div>
	);

	const mainContent = (
		<>
			{props.useHeader && <div className={styles.cardHeader}>{title}</div>}
			{((title && !props.useHeader) || props.description) && (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "6px",
						...(props.useHeader ? { padding: "0 15px" } : {}),
					}}
				>
					{!props.useHeader && title}
					{props.description && (
						<div className={styles.cardDescription} style={{ fontSize: props.fontSize, lineHeight: props.lineHeight }}>
							{props.description}
						</div>
					)}
				</div>
			)}
			{props.children && (
				<div
					className={props.bodyClassName}
					style={{
						padding: props.useHeader ? (props.padding ?? "0 15px") : 0,
						fontSize: props.fontSize,
						height: "100%",
					}}
				>
					{" "}
					{props.children}{" "}
				</div>
			)}
		</>
	);

	return (
		<div
			className={`${styles.card} ${props.className || ""}`}
			style={{
				...(props.style ?? {}),
				flexDirection: "column",
				...(props.useHeader ? { padding: 0, paddingBottom: props.bottomPadding ?? 12 } : {}),
				boxShadow: props.boxShadow ? "0 0 5px 0 rgb(0 0 0/20%)" : undefined,
				border: props.boxShadow ? "none" : undefined,
			}}
		>
			{props.rightContent ? (
				<div className={styles.rightContentWrapper}>
					{mainContent}
					{props.rightContent}
				</div>
			) : (
				mainContent
			)}
		</div>
	);
};
